<template>
    <div class="d-flex align-items-center">
        <select class="form-select" 
            v-model="assessment" 
            :class="evalClass" 
            @change="change"
            >
            <option v-for="(str, key) in evalValues" :value="key">{{ key }} &VerticalLine; {{ str }}</option>
        </select>
        <worksheet-note v-model="notesData" @input="change"></worksheet-note>
    </div>
</template>

<script>
import axios from "axios";
import WorksheetNote from "./WorksheetNote.vue";

export default {
    components: { WorksheetNote },

    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return data;
            },
        },

        worksheets_dates_id: {
            type: Number,
            default: null,
        },

        evaluation_date: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            assessment: this.value.assessment ?? 0,
            duration: this.value.duration ?? 0,
            notes: this.value.notes ?? '',
            id: this.value.id ?? null,

            pending: false,

            evalValues: {
                0: 'No evaluation',
                1: 'Not Yet Adequate, little or no growth',
                2: 'Not Yet Adequate, but showing some growth',
                3: 'Adequate Progress',
                4: 'Mastery understanding'
            },

        }
    },

    computed: {
        notesData: {
            get() {
                return {
                    notes: this.notes,
                    duration: this.duration,
                };
            },

            set(data={}) {
                this.notes = data.notes ?? '',
                this.duration = data.duration ?? 0;
            },
        },

        evalClass: function() {
            switch (parseInt(this.assessment)) {
                case 4:
                    return 'border-success';
                case 3: 
                    return 'border-warning';
                case 2:
                    return 'border-danger';
                case 1:
                    return 'border-danger';
                default:
                    return '';
            }
        },
    },

    updated: function() {
        console.log('ASSESSMENT UPDATE');
    },

    watch: {
        worksheets_dates_id: function (n, o) {
            if (this.pending) {
                console.debug('Found pending worksheet date');
                this.create();
            }
        },

        value: function (n, o) {
            this.assessment = n.assessment ?? 0;
            this.notes = n.notes ?? '';
            this.duration = n.duration ?? 0;
            this.id = n.id ?? null;
        }
    },

    methods: {
        change(event) {
            if (parseInt(this.assessment) || parseInt(this.duration) || this.notes) {
                console.debug(` Assessment: ${this.assessment}`);
                console.debug(` Duration: ${this.duration}`);
                console.debug(` Notes: ${this.notes}`);
                if (this.id) {
                    this.update();
                } else {
                    this.create();
                }
            } else {
                this.remove();
            }
        },

        create: function() {
            console.debug('Create assessment');
            if (this.worksheets_dates_id) {
                const data = {
                    assessment: this.assessment,
                    duration: this.duration,
                    notes: this.notes,
                    standards_id: this.value.standards_id,
                    students_id: this.value.students_id,
                    worksheets_dates_id: this.worksheets_dates_id,
                };

                axios
                    .post('/api/worksheet/assess', data)
                    .then(response => {
                        this.id = response.data.assessment.id;
                        this.$emit('create', response.data);
                    })
                    .catch(error => {
                        console.error(error);
                        console.error(error.response);
                    })
                    .finally(() => {
                        this.pending = false;
                    });
            } else {
                console.debug('WORKSHEET DATE NOT FOUND');
                this.pending = true;
                this.$emit('create-worksheet-date');
            }
        },

        update: function() {
            console.log('Update assessment');
            const data = {
                assessment: this.assessment,
                duration: this.duration,
                notes: this.notes,
                standards_id: this.value.standards_id,
                students_id: this.value.students_id,
                worksheets_dates_id: this.worksheets_dates_id,
            };

            axios
                .put(`/api/worksheet/assess/${this.id}`, data)
                .then(response => {
                    this.id = response.data.assessment.id;
                    this.$emit('update', response.data);
                })
                .catch(error => {
                    console.error(error);
                    console.error(error.response);
                })
                .finally(() => {
                    this.pending = false;
                });
        },

        remove: function() {
            axios
                .delete(`/api/worksheet/assess/${this.id}`)
                .then(response => {
                    this.$emit('remove', this.id);
                    this.id = null;
                })
                .catch(error => {
                    console.error(error);
                    console.error(error.response);
                })
                .finally(() => {
                });
        },


        /**
         * If ID:
         *  - No assessment, duration, notes := Delete
         *  - Else := Update
         * If no ID:
         *  - Worksheet ID := New assessment
         *  - No worksheet ID:
         *      - Create new  worksheet
         *      - Update parent
         *      - New assessment
         */

        // update: function() {
        //     if (this.id) {
        //         if (!(parseInt(this.assessment) || this.duration || this.notes)) {
        //             axios
        //                 .delete(`/api/worksheet/assess/${this.id}`)
        //                 .then(response => {
        //                     this.$emit('delete', this.id);
        //                 })
        //                 .catch(error => {
        //                     console.error(error);
        //                     console.error(error.response);
        //                 })
        //                 .finally(() => {
        //                 });
        //         } else {
        //             const data = {
        //                 assessment: this.assessment,
        //                 duration: this.duration,
        //                 id: this.id,
        //                 notes: this.notes,
        //                 standards_id: this.value.standards_id,
        //                 students_id: this.value.students_id,
        //                 worksheets_dates_id: this.value.worksheets_dates_id,
        //                 evaluation_date: this.evaluation_date,
        //                 worksheets_id: this.worksheets_id,
        //             };

        //             axios
        //                 .put('/api/worksheet/assess', data)
        //                 .then(response => {
        //                     this.$emit('update', response.data);
        //                 })
        //                 .catch(error => {
        //                     console.error(error);
        //                     console.error(error.response);
        //                 })
        //                 .finally(() => {
        //                 });
        //             }
        //     } else {
        //         if (this.worksheets_id) {
        //             console.log('HAS WORKSHEET ID');
        //         } else {
        //             console.log('NO WORKSHEET ID');
        //             this.$root.$emit('create-worksheet');
        //         }
        //     }
        // },


        // updateNote: function(event) {
        //     this.notesData = event;
        //     this.update();
        // }
    },

}
</script>